/** A household the server hides (a village with fewer than 5 households, a caller without pii.read). */
export const SMALL_AREA = 'Rumah tangga di wilayah kecil (disembunyikan)';
